import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useQuery} from 'react-query'

import Item from './Item'
import * as orderDeclinesQueries from '../../../queries/orderdeclines.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function OrderDeclinesView({params}) {
    const orderDeclinesQuery = useQuery(
        ['id', params.id],
        orderDeclinesQueries.getOrderDeclinesById,
    )

    const declines = orderDeclinesQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, declines?.order_timezone, options)
    const zoneLine = zoneNotice(
        declines?.order_timezone,
        declines?.order_timezone_source,
    )

    if (orderDeclinesQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>
            <div className="order">
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{
                            background: 'rgba(0,0,0,0.03)',
                            paddingTop: '1.05rem',
                        }}
                        header={<Title level={5}>Basic Info</Title>}>
                        <Item body={declines.id} title="ID#" />
                        <Item
                            body={
                                <Link to={`/booking/${declines.order_id}`}>
                                    {declines.order_id}
                                </Link>
                            }
                            title="Order ID "
                        />
                        <Item
                            body={
                                <Link to={`/user/${declines.gopher_id}`}>
                                    {declines.gopher}
                                </Link>
                            }
                            title="Gopher Name"
                        />
                        <Item
                            body={fmt(declines.createdon, {dateOnly: true})}
                            title="Created On"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default OrderDeclinesView
